
document.addEventListener("DOMContentLoaded", function () {
const sidebar = document.querySelector(".siderbar");
  if (sidebar) {
    sidebar.style.display = "block";
  }

  const toggles = document.querySelectorAll(".main-svg-box-menu .svg-wrapper");

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();

      const currentItem = this.closest(".list-menu__item");
      const currentSubmenu = currentItem.querySelector(":scope > .submenu-cat");

      // Close all sibling submenus at the same depth
      const siblingItems = currentItem.parentElement.querySelectorAll(":scope > .list-menu__item");

      siblingItems.forEach((sibling) => {
        if (sibling !== currentItem) {
          sibling.classList.remove("cat-active-li");
          const submenu = sibling.querySelector(":scope > .submenu-cat");
          if (submenu) submenu.style.display = "none";
        }
      });

      // Toggle current submenu
      if (currentSubmenu) {
        const isOpen = currentSubmenu.style.display === "block";
        currentSubmenu.style.display = isOpen ? "none" : "block";
        currentItem.classList.toggle("cat-active-li", !isOpen);
      }
    });
  });

function showMobileMenu() {
    if (window.innerWidth < 767) {
      const mobileMenu = document.querySelector(".mobile-cat-menu");
      if (mobileMenu) {
        mobileMenu.style.display = "block";
      }
    }
  }

  // // Run on first load
  // showMobileMenu();

  // // Run again after Shopify section reload (AJAX filter updates)
  // document.addEventListener("shopify:section:load", function () {
  //   showMobileMenu();
  // });

  // Some themes trigger this custom event on filter update
  document.addEventListener("facet:filter:updated", function () {
    showMobileMenu();
  });
 const contentcat = document.querySelector(".mobile-cat-menu");
  if (!contentcat) return;

  window.addEventListener("scroll", function () {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop >= 61) {
      contentcat.classList.add("activemob-cat");
    } else {
      contentcat.classList.remove("activemob-cat");
    }
  });
document.querySelectorAll('.facet-checkbox--disabled').forEach(el => {
  const li = el.closest('li');
  if (li) {
    li.style.display = 'none';
  }
});


});